import Styled, {css} from 'styled-components';
import {ColorUtils} from '../../utils';

export const CenterWrapper = Styled.div`
	margin-left: auto;
	margin-right: auto;
`;

const NoWidthLimitStyle = css`
	display: inline-flex;
	max-width: none;
`;

const ProjectIndicatorStyle = css`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	overflow: hidden;
	color: ${props => ColorUtils.getInvertedTextColor(props.color)};
	outline: ${props => (props.showOutline ? '' : 'none')};
	outline-color: black;
	white-space: nowrap;

	min-width: ${props => (props.small ? '38px' : '46px')};
	max-width: ${props => (props.small ? '38px' : '46px')};
	height: 20px;
	padding-left: ${props => (props.small ? '4px' : '6px')};
	padding-right: ${props => (props.small ? '4px' : '6px')};
	padding-top: 1px;
	border-radius: 6px;
	background-color: ${props => props.color};
	font-size: 10px;
	font-weight: 700;
	text-decoration: none;
	cursor: ${props => (props.isDisabled ? 'inherit' : 'pointer')};

	${props => props.noWidthLimit && NoWidthLimitStyle};

	&:hover {
		color: ${props => ColorUtils.getInvertedTextColor(props.color)};
		outline: ${props => (props.showOutline ? 'solid' : 'none')};
		outline-color: black;
	}
`;

export const ProjectIndicatorLink = Styled.a`
	${ProjectIndicatorStyle}
`;

export const ProjectIndicatorNoLink = Styled.div`
	${ProjectIndicatorStyle}
`;
